/**
 * The call's bar, left to right with Leave at the end (job 6): round
 * buttons, no labels (each one's name is its tooltip and its accessible
 * name), one gap between every two. No Message: it left the call
 * (decision 132), and the call's chat reaches the thread while only one is
 * in. Recommend only where the lesson allows an offer; one button that opens
 * and closes the match; More only for the player's invite once guests are
 * open (coaches have no Invite, decision 62). Record, after the media
 * controls, for anyone who may turn the call's recording off and on (not a
 * lesson's guest; docs/call-recording.md). Hide cameras is on the stage,
 * not here (decision 131). Pure, so tested.
 */
export type BarButton = 'mic' | 'camera' | 'share' | 'chat' | 'recommend' | 'match' | 'more' | 'leave';

export function barButtons(p: {
  isCoach: boolean; booked: boolean; canShare: boolean; theyAreIn: boolean; hasOther: boolean;
  offers: number; hasMatch: boolean; guestJoin: boolean;
  /** The match is open on this side now. */
  matchOpen?: boolean;
}): BarButton[] {
  // No Record control (163): every call records by default (158), and the bar never offers to stop it.
  const out: BarButton[] = ['mic', 'camera'];
  if (p.canShare) out.push('share');
  out.push('chat');
  if (p.isCoach && p.booked && p.offers > 0) out.push('recommend');
  if (p.isCoach && p.hasMatch) out.push('match');
  if (!p.isCoach && p.booked && p.guestJoin) out.push('more');
  out.push('leave');
  return out;
}

/**
 * The bar grouped as Meet's (141): on a larger screen the lesson and its
 * time at the left, the controls in the middle with Leave at their end,
 * and the panel's button, Chat, in the right corner. On a phone every
 * button is one centred row that shares the bar's width.
 */
export function barGroups(buttons: BarButton[], large: boolean): { center: BarButton[]; corner: BarButton[] } {
  if (!large) return { center: buttons, corner: [] };
  return { center: buttons.filter((b) => b !== 'chat'), corner: buttons.filter((b) => b === 'chat') };
}
